import React, { Component } from 'react';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  blue500,
  blue700,
  blueGrey100,
  blueGrey500,
  darkBlack,
  grey300,
  lightBlack,
  purpleA200,
  lightGreen900,
  lime500,
  deepOrange500,
  lightGreenA400,
  lightGreen500,
  white
} from 'material-ui/styles/colors';
import Avatar from 'material-ui/Avatar';
import spacing from 'material-ui/styles/spacing'
import { fade } from 'material-ui/utils/colorManipulator'
import Drawer from 'material-ui/Drawer';
import { List, ListItem } from 'material-ui/List';
import AppBar from 'material-ui/AppBar';
import injectTapEventPlugin from 'react-tap-event-plugin';
import BuildList from './components/build-list'
import FontIcon from 'material-ui/FontIcon';
import navList from './data/nav.json'
import './App.css';
import GoogleLogin from 'react-google-login';

injectTapEventPlugin();

const styles = {
  iconStyles: {
    marginRight: 24,
  }
};

const muiTheme = getMuiTheme({
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopLeftNavMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56,
  },
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: blue500,
    primary2Color: blue700,
    primary3Color: lightBlack,
    accent1Color: purpleA200,
    accent2Color: blueGrey100,
    accent3Color: blueGrey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: blue500,
    backCanvas: {
      viewportBackgroundColor: white,
      navDrawerBoxShadow: true
    },
  },
  avatar: {
    borderColor: white,
  },
});

class App extends Component {
  constructor(props) {
    super(props);   
    var isLoggedIn = false; 
    var time = parseInt(localStorage.getItem("auth_expiry"));    
    if(!isNaN(time)){    
        if(Math.abs(time - Date.now())/36e5 > 1){          
          localStorage.clear(); 
        }
      else{
        isLoggedIn = true;
      }
      
    }
    this.state = { open: false, showProgressIndicator: false, isLoggedIn : isLoggedIn};
    console.log(localStorage.getItem("user"));
    this.setState({user : localStorage.getItem("user")});
    //this.getPavarottiBranchInformation();
  }

  onMenuToggle = () => this.setState({ open: !this.state.open });

  onListItemClick = (data) => {
    if (!data.Prefix)
      return;
    this.setState({
      open: false,
      builds: [],
      showProgressIndicator: true,
      config: data
    })
    //let url = `http://localhost:8081?prefix=${data.Prefix}`;
    let url = `https://vk89870z3d.execute-api.us-east-1.amazonaws.com/prod?prefix=${data.Prefix}`;
    fetch(url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res.json())
      .then((resJson) => {
        this.setState({
          open: false,
          builds: resJson,
          showProgressIndicator: false,
          config: data
        });
      });
  }

  getIcon = (name) => {
    if (name == 'android')
      return <FontIcon className="material-icons" color={lightGreen500}>{name}</FontIcon>;
    else if(name == 'phone_iphone')
      return <FontIcon className="material-icons" color={blue500}>{name}</FontIcon>;
    else
    return <FontIcon className="material-icons" color={purpleA200}>{name}</FontIcon>;
  };
  getAvatar = (name) => {
    if (name == 'android')
      return <Avatar icon={<FontIcon className="material-icons" >{name}</FontIcon>} backgroundColor={lightGreen500} />;
    else
      return <Avatar icon={<FontIcon className="material-icons" color={blue500}>{name}</FontIcon>} backgroundColor={blue500} />;

  };

  createBuildObject = (buildObject, data) => {
    let newBranch = Object.assign({}, buildObject);
    newBranch.Prefix = newBranch.Prefix.replace('master', data.name);
    newBranch.Name = data.name;
    newBranch.Header = newBranch.Header.replace('Master', data.name);
    return newBranch;
  };

  getPavarottiBranchInformation = () => {

    let url = `https://api.github.com/repos/Logitech/shg-pavarotti-apps/branches?access_token=a0a8c13c26cbcdf00c8039a2998a7d6d1fcd069f`;
    fetch(url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((res) => res.json())
      .then((resJson) => {
        resJson.forEach((item) => {
          activeAndroidBranches.Branch.push(this.createBuildObject(androidBuildInfo, item));
          activeIosBranches.Branch.push(this.createBuildObject(iosBuildInfo, item));
        });
      });

    let androidBuildInfo = {
      "Name": "Master",
      "Header": "Android-Pavarotti / Master",
      "Prefix": "Pavarotti/android/master/",
      "ChangeLogUrl": "http://use1ecibuilds01.idc.logitech.com:8080/blue/organizations/jenkins/shg-pavarotti-apps/detail/Devops_poc/26/changes#",
      "AppName": "app-debug.apk",
      "BucketUrl": "https://builds.myharmony.com/",
      "Template": "Android"
    };

    let iosBuildInfo =
      {
        "Name": "Master",
        "Header": "iOS-Pavarotti/Master",
        "Prefix": "Pavarotti/iOS/master/",
        "ChangeLogUrl": "http://iosbuilds.idc.logitech.com:8080/job/Brownie_master/changes",
        "AppName": "Brownie.ipa",
        "PlistName": "Brownie.plist",
        "BucketUrl": "https://builds.myharmony.com/",
        "iOSInstallUrl": "itms-services://?action=download-manifest&url=",
        "Template": "iOS"
      };


    let activeAndroidBranches = {
      "Name": "Android - Pavarotti",
      "IconName": "android",
      "IsOpen": false,
      "Branch": []
    };

    let activeIosBranches = {
      "Name": "iOS - Pavarotti",
      "IconName": "phone_iphone",
      "IsOpen": false,
      "Branch": []
    };

    navList.push(activeAndroidBranches);
    navList.push(activeIosBranches);

  }

  buildMenus = (list, keyName) => {
    // leftAvatar={item.Branch ? this.getAvatar(item.IconName) : null}
    if (list)
      return list.map((item) => {
        return (<ListItem
          key={item[keyName]}
          className="menu"
          primaryText={item[keyName]}
          initiallyOpen={item.IsOpen}
          primaryTogglesNestedList={item.Branch ? true : false}
          leftIcon={item.Branch ? this.getIcon(item.IconName) : null}
          onTouchTap={this.onListItemClick.bind(this, item)}
          nestedItems={this.buildMenus(item.Branch, "Name")}></ListItem>)
      })
  }

  responseGoogle = (response) => {    
    if(response.profileObj && response.tokenObj){      
      localStorage.setItem("bs_authtoken",response.tokenObj.access_token);
      localStorage.setItem("auth_expiry",Date.now());
      localStorage.setItem("user",response.profileObj.name);
      this.setState({isLoggedIn : true, user : response.profileObj.name});
    }
    
  }

  render() {
    let { builds, showProgressIndicator, config } = this.state;    
      let styles = {      
        button : {
          background: "#2196F3",
          padding: "10px",          
          color: "#ffffff",
          align : "center",
          fontweight : "400",
          width : "200"                
        },
        background: "#2196F3"              
      }    
    let user = localStorage.getItem("user");
    
    if(!this.state.isLoggedIn){
      return(
        <MuiThemeProvider>
          <div>
          <AppBar
             title="Build Dashboard" style = {styles}
           />           
              <GoogleLogin
                clientId="439747102374-svc9c6g06tujip1ksmctc8j0rt47q6e1.apps.googleusercontent.com"
                buttonText="   Login   "
                hostedDomain = "logitech.com"
                onSuccess={this.responseGoogle}
                onFailure={this.responseGoogle}
                buttonText = "Sign In"
                style = {styles.button}
              />
         </div>
         </MuiThemeProvider>
      );      
    }
    else{
      return (
        <MuiThemeProvider muiTheme={muiTheme}>
          <div className="App">
          {console.log(localStorage.getItem("user"))}
            <AppBar title={"Welcome, " + user} onLeftIconButtonTouchTap={this.onMenuToggle} />
            <Drawer
              docked={false}
              width={275}
              open={this.state.open}
              onRequestChange={(open) => this.setState({ open })}>
              <List children={this.buildMenus(navList, "Name")}>
              </List>
            </Drawer>
            <div>
              <BuildList builds={builds} config={config} showProgressIndicator={showProgressIndicator}></BuildList>
            </div>
          </div>
        </MuiThemeProvider>
  
      );
    }    
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js